module.exports = __webpack_public_path__ + "img/sa.98a57ba7.png";